import { Autocomplete, Box, Button, TextField, Typography } from "@mui/material"
import { useFormik } from "formik"


const LessonFilters = ({ initialValues, onSubmit, subjectOptions, subjectLookups, groupOptions, groupLookups, onClose, showGroupsFilter = true }) => {

    const { values, handleChange, setFieldValue, handleSubmit } = useFormik({
        initialValues,
        onSubmit: values => {
            onSubmit(values)
            onClose()
        },
    })

    return <Box sx={{ minWidth: 300, p: 2 }}>
        <Autocomplete
            id="subject"
            value={values.subject}
            options={subjectOptions}
            getOptionLabel={option => subjectLookups[option]?.name ?? ""}
            onChange={(_, value) => setFieldValue("subject", value)}
            fullWidth
            renderInput={props => <TextField label="Предмет" id="subject" {...props} />}
        />
        {showGroupsFilter && <>
            <Autocomplete
                id="group"
                value={values.group}
                options={groupOptions}
                getOptionLabel={option => groupLookups[option]?.name ?? ""}
                onChange={(_, value) => setFieldValue("group", value)}
                fullWidth
                renderInput={props => <TextField label="Группа" id="group" {...props} />}
            />

            <Autocomplete
                options={[true, false]}
                value={values.mainGroup}
                onChange={(_, value) => setFieldValue("mainGroup", value)}
                getOptionLabel={option => option ? "Основные группы" : "Ознакомительные группы"}
                fullWidth
                renderInput={props => <TextField
                    label="Тип групп"
                    {...props}
                />}
            />
            <Autocomplete
                options={[1, 2]}
                value={values.studyYear}
                onChange={(_, value) => setFieldValue("studyYear", value)}
                getOptionLabel={option => `${option} год обучения`}
                fullWidth
                renderInput={props => <TextField
                    label="Год обучения"
                    {...props}
                />}
            />
        </>}

        <Typography sx={{ mt: 2 }} >Отображать занятия с</Typography>
        <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
            <TextField
                id="dateAfter"
                name="dateAfter"
                type="date"
                label="Дата"
                value={values.dateAfter}
                onChange={handleChange}
                slotProps={{ inputLabel: { shrink: true } }}
            />
            <TextField
                id="timeAfter"
                name="timeAfter"
                type="time"
                label="Время"
                value={values.timeAfter}
                onChange={handleChange}
                slotProps={{ inputLabel: { shrink: true } }}
            />
        </Box>
        <Typography>По</Typography>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <TextField
                id="dateBefore"
                name="dateBefore"
                type="date"
                label="Дата"
                value={values.dateBefore}
                onChange={handleChange}
                slotProps={{ inputLabel: { shrink: true } }}
            />
            <TextField
                id="timeBefore"
                name="timeBefore"
                type="time"
                label="Время"
                value={values.timeBefore}
                onChange={handleChange}
                slotProps={{ inputLabel: { shrink: true } }}
            />
        </Box>

        <Button onClick={handleSubmit} fullWidth variant="contained" sx={{ mt: 1 }}>
            Применить фильтры
        </Button>
    </Box>
}

export default LessonFilters